import Link from 'next/link';
import Image from 'next/legacy/image';
import styled from 'styled-components';
// import MarkdownRender from './markdown-render';
import MetaInfo from './meta-info';
import MetaTags from './meta-tags';
import BookmarkButton from './bookmark-button';
import { useUserData, assessmentStatus } from 'utils/user';

import ProgressHexagon from 'components-new/progress-hexagon';
import assessmentStatusApi from '../apiFrontend/assessmentStatusApi';

export type AssessmentItemProps = {
  assessment: Assessment;
  completed?: boolean;
};

export const AssessmentItem: React.FC<AssessmentItemProps> = ({ assessment }) => {
  const { achievements, loggedIn } = useUserData();
  const { data: assessmentStatusData } = assessmentStatusApi.useGetAssessmentStatusQuery(assessment.meta.id, {
    skip: !loggedIn,
  });

  return (
    <StyledAssessmentItem className={`assessment-item`}>
      <ProgressHexagon status={assessmentStatus(achievements, assessment, assessmentStatusData?.status)} />
      <div className="inner">
        <div className="image">
          {assessment.icon ? (
            <div className="header-icon">
              <Image
                src={assessment.icon.url}
                width={assessment.icon.width}
                height={assessment.icon.height}
                alt={assessment.icon.title}
                sizes="112px"
                quality={100}
              />
            </div>
          ) : (
            <div className="empty-header-icon"></div>
          )}
        </div>
        <div className="content">
          <Link href={assessment.meta.path}>
            <h3 className="header">{assessment.title}</h3>
          </Link>
          <MetaInfo readingTime={assessment.meta.readingTime} type="ASSESSMENT" />
          <MetaTags tags={assessment.meta.tags} />
          {/* <MarkdownRender markdown={assessment.body} /> */}
        </div>
      </div>
      <div className="footer">
        <BookmarkButton moduleId={assessment.meta.id} learningPathId={assessment.meta.parent?.id} />
      </div>
    </StyledAssessmentItem>
  );
};

export const StyledAssessmentItem = styled.div`
  background: var(--body-background);
  border: 1px solid var(--border-white-high-contrast);
  box-shadow: 0 1.6px 3.6px 0 var(--box-shadow-medium), 0 0.3px 0.9px 0 var(--box-shadow-light);
  display: flex;
  flex-direction: column;
  position: relative;

  .inner {
    display: flex;
    padding: 1.5rem;
    position: relative;
  }

  .xp-hexagon {
    right: 3rem;
    top: 3rem;
  }

  .image {
    width: 96px;

    .empty-header-icon {
      width: 96px;
      height: 96px;
      background: #52b3c0;
      border: 3px solid #438c94;
      border-radius: 50%;
    }
  }

  .content {
    padding: 1.5rem;
    flex: 1 1 0;

    .h3 {
      font-size: 1.125rem;
      margin-bottom: 0;
    }

    .learning-objectives {
      margin: 1rem 0;
      font-size: 0.875rem;

      ul {
        margin: 16px 0;
        margin-left: 38px;
        li {
          list-style: disc none outside;
        }
      }
    }

    .buttons {
      display: flex;
      gap: 0.5rem;
      margin: 1rem 0;
    }
  }

  h3.header {
    font-size: 1.125rem;
    margin: 0;
  }

  .units {
    margin: 0.5rem 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .footer {
    padding: 0.25rem 1rem 0.25rem 0.5rem;
    border-top: 1px solid var(--border);
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;

export default AssessmentItem;
